import { ComputedRef, computed } from 'vue';
import { Period } from '@/ts/composables/usePeriod';

// Factory for creating instance-scoped data time state
export function createDataTime(dependencies: {
  period: ComputedRef<number>;
  dates: ComputedRef<Date[] | null>;
  lastUpdated: ComputedRef<string | null>;
}) {
  const dateRange = computed(() => {
    if (dependencies.dates.value === null)
      return '';

    const dateIndex = Math.min(dependencies.period.value - 1, dependencies.dates.value.length - 1);
    const startDate = new Date(dependencies.dates.value[dateIndex]);
    const endDate = new Date(dependencies.dates.value[0]);

    const startDateString = startDate.toLocaleDateString('en-US', { timeZone: 'UTC' });
    const endDateString = endDate.toLocaleDateString('en-US', { timeZone: 'UTC' });
    if (dependencies.period.value === Period.Latest)
      return startDateString;

    return `${startDateString} - ${endDateString}`;
  });

  const formattedTimestamp = computed(() => {
    if (dependencies.lastUpdated.value === null)
      return '';

    const timestampDate = new Date(dependencies.lastUpdated.value);
    const timeString = timestampDate.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'America/New_York',
      hour12: false
    });
    return `${timeString} ET`;
  });

  return { dateRange, formattedTimestamp };
}
